"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _events = require("events");

var _awsAmplify = _interopRequireWildcard(require("aws-amplify"));

var _seamlessImmutable = _interopRequireDefault(require("seamless-immutable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var seamless = _seamlessImmutable.default.from;

var CognitoDatasetManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(CognitoDatasetManager, _EventEmitter);

  var _super = _createSuper(CognitoDatasetManager);

  function CognitoDatasetManager() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        authConfig = _ref.authConfig,
        _ref$dataPrivacyLevel = _ref.dataPrivacyLevel,
        dataPrivacyLevel = _ref$dataPrivacyLevel === void 0 ? "private" : _ref$dataPrivacyLevel,
        _ref$privateDataExpir = _ref.privateDataExpire,
        privateDataExpire = _ref$privateDataExpir === void 0 ? 24 * 60 * 60 : _ref$privateDataExpir;

    _classCallCheck(this, CognitoDatasetManager);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "type", "cognito");

    _defineProperty(_assertThisInitialized(_this), "ds", null);

    _defineProperty(_assertThisInitialized(_this), "proxyUrl", "https://cors-anywhere.herokuapp.com/");

    _defineProperty(_assertThisInitialized(_this), "isReady", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _awsAmplify.Auth.currentAuthenticatedUser().then(function () {
                return true;
              }).catch(function () {
                return false;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "getSummary", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var index;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.ds) {
                _context2.next = 15;
                break;
              }

              _context2.next = 3;
              return _this.getJSON(_this.projectName + "/index.json");

            case 3:
              index = _context2.sent;
              _context2.t0 = seamless;
              _context2.next = 7;
              return _this.getSamplesSummary();

            case 7:
              _context2.t1 = _context2.sent;
              _context2.t2 = {
                samples: _context2.t1
              };
              _context2.t3 = index.interface;
              _context2.t4 = _this.projectName;
              _context2.t5 = {
                summary: _context2.t2,
                interface: _context2.t3,
                name: _context2.t4
              };
              _this.ds = (0, _context2.t0)(_context2.t5);
              _context2.next = 19;
              break;

            case 15:
              if (_this.ds.summary) {
                _context2.next = 19;
                break;
              }

              _context2.next = 18;
              return _this.getSamplesSummary();

            case 18:
              _this.ds.summary = _context2.sent;

            case 19:
              return _context2.abrupt("return", _this.ds.summary);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "getProjects", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var list, projets;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _awsAmplify.Storage.list("", {
                level: _this.dataPrivacyLevel
              });

            case 2:
              list = _context4.sent;
              projets = new Set();
              _context4.next = 6;
              return Promise.all(list.map( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(obj) {
                  var possibleProjects;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (obj.size) {
                            possibleProjects = obj.key.split("/")[0];
                            if (possibleProjects) projets.add(possibleProjects);
                          } else {
                            if (obj.key.split("/")[0] !== "") {
                              projets.add(obj.key.split("/")[0]);
                            }
                          }

                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 6:
              return _context4.abrupt("return", projets);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "getListAssets", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref6) {
        var _ref6$projectName, projectName, result, assets;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref6$projectName = _ref6.projectName, projectName = _ref6$projectName === void 0 ? false : _ref6$projectName;
                if (!projectName) projectName = _this.projectName;
                _context5.next = 4;
                return _awsAmplify.Storage.list("".concat(projectName, "/assets/"), {
                  level: _this.dataPrivacyLevel
                });

              case 4:
                result = _context5.sent;
                assets = result.filter(function (obj) {
                  return obj.key !== "".concat(projectName, "/assets/");
                }).map(function (obj) {
                  return obj.key;
                });
                return _context5.abrupt("return", assets);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x2) {
        return _ref7.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getListSamples", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref8) {
        var _ref8$projectName, projectName, result, samples;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref8$projectName = _ref8.projectName, projectName = _ref8$projectName === void 0 ? false : _ref8$projectName;
                if (!projectName) projectName = _this.projectName;
                _context6.next = 4;
                return _awsAmplify.Storage.list("".concat(projectName, "/samples/"), {
                  level: _this.dataPrivacyLevel
                });

              case 4:
                result = _context6.sent;
                samples = result.filter(function (obj) {
                  return obj.key !== "".concat(projectName, "/samples/");
                }).map(function (obj) {
                  return obj.key;
                });
                return _context6.abrupt("return", samples);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setProject", function (projectName) {
      // This should be moved in a project manager later on
      _this.projectName = projectName;
    });

    _defineProperty(_assertThisInitialized(_this), "createProject", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(indexjson) {
        var projects;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this.getProjects();

              case 2:
                projects = _context7.sent;

                if (!(projects && !projects.has(indexjson.name))) {
                  _context7.next = 9;
                  break;
                }

                _context7.next = 6;
                return _awsAmplify.Storage.put("".concat(indexjson.name, "/index.json"), indexjson, {
                  level: _this.dataPrivacyLevel,
                  contentType: "application/json"
                });

              case 6:
                return _context7.abrupt("return", true);

              case 9:
                console.log("Project with the same name already exist");
                return _context7.abrupt("return", false);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "readJSONAllSample", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(listSamples) {
        var json, i;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                json = new Array(listSamples.length);
                i = 0;

              case 2:
                if (!(i < listSamples.length)) {
                  _context8.next = 9;
                  break;
                }

                _context8.next = 5;
                return _this.getJSON(listSamples[i]);

              case 5:
                json[i] = _context8.sent;

              case 6:
                i++;
                _context8.next = 2;
                break;

              case 9:
                return _context8.abrupt("return", json);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getJSON", /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(path) {
        var url, blob, json;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _awsAmplify.Storage.get(path, {
                  expires: _this.privateDataExpire,
                  level: _this.dataPrivacyLevel,
                  contentType: "application/json"
                });

              case 2:
                url = _context9.sent;
                _context9.next = 5;
                return fetch(url);

              case 5:
                blob = _context9.sent;
                _context9.next = 8;
                return blob.json();

              case 8:
                json = _context9.sent;
                return _context9.abrupt("return", json);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x6) {
        return _ref12.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setJSON", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path, json) {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _awsAmplify.Storage.put(path, json, {
                  level: _this.dataPrivacyLevel
                }).catch(function (err) {
                  return console.log(err);
                });

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x7, _x8) {
        return _ref13.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getSamplesSummary", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      var listSamples, json, listJson;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this.getListSamples({
                projectName: _this.projectName,
                noExtensions: false
              });

            case 2:
              listSamples = _context11.sent;
              _context11.next = 5;
              return _this.readJSONAllSample(listSamples);

            case 5:
              json = _context11.sent;
              listJson = json.map(function (obj) {
                return {
                  hasAnnotation: obj.annotation ? true : false,
                  _id: obj._id,
                  //TODO create fonction to get all url
                  _url: obj.imageUrl
                };
              });
              return _context11.abrupt("return", listJson);

            case 8:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    })));

    _defineProperty(_assertThisInitialized(_this), "getDatasetProperty", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(key) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (_this.ds) {
                  _context12.next = 3;
                  break;
                }

                _context12.next = 3;
                return _this.getSummary();

              case 3:
                return _context12.abrupt("return", _this.ds[key]);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setDatasetProperty", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(key, newValue) {
        var dataset, path, jsonToChange;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.t0 = key;
                _context14.next = _context14.t0 === "samples" ? 3 : _context14.t0 === "name" ? 6 : 16;
                break;

              case 3:
                _context14.next = 5;
                return Promise.all(newValue.map( /*#__PURE__*/function () {
                  var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(obj) {
                    return regeneratorRuntime.wrap(function _callee13$(_context13) {
                      while (1) {
                        switch (_context13.prev = _context13.next) {
                          case 0:
                            _context13.next = 2;
                            return _this.setJSON(_this.projectName + "/samples/" + obj._id + ".json", obj);

                          case 2:
                          case "end":
                            return _context13.stop();
                        }
                      }
                    }, _callee13);
                  }));

                  return function (_x12) {
                    return _ref17.apply(this, arguments);
                  };
                }()));

              case 5:
                return _context14.abrupt("break", 24);

              case 6:
                _context14.next = 8;
                return _this.getDataset();

              case 8:
                dataset = _context14.sent;
                dataset.name = newValue;
                /*var assets=await Promise.all(
                  summary.samples.map(async (obj) => {
                    return await this.fetchAFile(obj._url)
                  })
                )*/

                _context14.next = 12;
                return _this.removeProject(_this.projectName);

              case 12:
                _context14.next = 14;
                return _this.setDataset(dataset);

              case 14:
                _this.setProject(dataset.name);

                return _context14.abrupt("break", 24);

              case 16:
                path = _this.projectName + "/index.json";
                _context14.next = 19;
                return _this.getJSON(path);

              case 19:
                jsonToChange = _context14.sent;
                jsonToChange[key] = newValue;
                _context14.next = 23;
                return _this.setJSON(path, jsonToChange);

              case 23:
                return _context14.abrupt("break", 24);

              case 24:
                _this.ds = undefined;
                _context14.next = 27;
                return _this.getSummary();

              case 27:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x10, _x11) {
        return _ref16.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getDataUrl", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(sampleRefId) {
        var url;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _awsAmplify.Storage.get(_this.projectName + "/assets/" + sampleRefId, {
                  expires: _this.privateDataExpire,
                  level: _this.dataPrivacyLevel
                }).then(function (_url) {
                  return _url;
                }).catch(function () {
                  return null;
                });

              case 2:
                url = _context15.sent;
                return _context15.abrupt("return", url);

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x13) {
        return _ref18.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getSampleByIndex", /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(index) {
        var sampleRefId, sample;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                sampleRefId = _this.ds.summary.samples[index]._id;
                _context16.next = 3;
                return _this.getSample(sampleRefId);

              case 3:
                sample = _context16.sent;
                return _context16.abrupt("return", sample);

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      return function (_x14) {
        return _ref19.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getSample", /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(sampleRefId) {
        var json;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return _this.getJSON(_this.projectName + "/samples/" + sampleRefId + ".json");

              case 2:
                json = _context17.sent;
                return _context17.abrupt("return", json);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x15) {
        return _ref20.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setSample", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(sampleRefId, newSample) {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return _this.setJSON(_this.projectName + "/samples/" + sampleRefId + ".json", newSample);

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x16, _x17) {
        return _ref21.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "addFile", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(name, blob) {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return _awsAmplify.Storage.put(_this.projectName + "/assets/" + name, blob, {
                  level: _this.dataPrivacyLevel
                }).catch(function (err) {
                  return console.log(err);
                });

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x18, _x19) {
        return _ref22.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "addSamples", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(samples) {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return Promise.all(samples.map( /*#__PURE__*/function () {
                  var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(obj) {
                    return regeneratorRuntime.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            _context20.next = 2;
                            return _this.setJSON(_this.projectName + "/samples/" + obj._id + ".json", obj);

                          case 2:
                          case "end":
                            return _context20.stop();
                        }
                      }
                    }, _callee20);
                  }));

                  return function (_x21) {
                    return _ref24.apply(this, arguments);
                  };
                }()));

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x20) {
        return _ref23.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "removeProject", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(projectName) {
        var result;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return _awsAmplify.Storage.list(projectName + "/", {
                  level: _this.dataPrivacyLevel
                });

              case 2:
                result = _context23.sent;
                _context23.next = 5;
                return Promise.all(result.map( /*#__PURE__*/function () {
                  var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(obj) {
                    return regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            _context22.next = 2;
                            return _awsAmplify.Storage.remove(obj.key, {
                              level: _this.dataPrivacyLevel
                            });

                          case 2:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22);
                  }));

                  return function (_x23) {
                    return _ref26.apply(this, arguments);
                  };
                }()));

              case 5:
                _this.getProjects();

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      return function (_x22) {
        return _ref25.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "removeSamples", /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(sampleIds) {
        var result;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return _awsAmplify.Storage.list(_this.projectName + "/samples/", {
                  level: _this.dataPrivacyLevel
                });

              case 2:
                result = _context25.sent;
                _context25.next = 5;
                return Promise.all(result.map( /*#__PURE__*/function () {
                  var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(obj) {
                    var i;
                    return regeneratorRuntime.wrap(function _callee24$(_context24) {
                      while (1) {
                        switch (_context24.prev = _context24.next) {
                          case 0:
                            i = 0;

                          case 1:
                            if (!(i < sampleIds.length)) {
                              _context24.next = 8;
                              break;
                            }

                            if (!obj.key.includes("/" + sampleIds[i] + ".json")) {
                              _context24.next = 5;
                              break;
                            }

                            _context24.next = 5;
                            return _awsAmplify.Storage.remove(obj.key, {
                              level: _this.dataPrivacyLevel
                            });

                          case 5:
                            i++;
                            _context24.next = 1;
                            break;

                          case 8:
                          case "end":
                            return _context24.stop();
                        }
                      }
                    }, _callee24);
                  }));

                  return function (_x25) {
                    return _ref28.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      return function (_x24) {
        return _ref27.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setDataset", /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(udtObject) {
        var index, jsons;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                index = {
                  name: udtObject.name,
                  interface: udtObject.interface
                };
                jsons = udtObject.samples;
                /*var assets=await Promise.all(
                  summary.samples.map(async (obj) => {
                    return await this.fetchAFile(obj._url)
                  })
                )*/

                _this.setProject(udtObject.name);

                _context26.t0 = Promise;
                _context26.next = 6;
                return _this.createProject(index);

              case 6:
                _context26.t1 = _context26.sent;
                _context26.next = 9;
                return _this.addSamples(jsons);

              case 9:
                _context26.t2 = _context26.sent;
                _context26.t3 = [_context26.t1, _context26.t2];
                _context26.next = 13;
                return _context26.t0.all.call(_context26.t0, _context26.t3);

              case 13:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      return function (_x26) {
        return _ref29.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getDataset", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
      var dataset;
      return regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return _this.getJSON(_this.projectName + "/index.json");

            case 2:
              dataset = _context27.sent;
              _context27.t0 = _this;
              _context27.next = 6;
              return _this.getListSamples(false);

            case 6:
              _context27.t1 = _context27.sent;
              _context27.next = 9;
              return _context27.t0.readJSONAllSample.call(_context27.t0, _context27.t1);

            case 9:
              dataset.samples = _context27.sent;
              return _context27.abrupt("return", dataset);

            case 11:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    })));

    if (!authConfig.Auth.region) throw new Error("Auth region is required");
    if (!authConfig.Auth.userPoolId) throw new Error("Auth userPoolId is required");
    if (!authConfig.Auth.userPoolWebClientId) throw new Error("Auth userPoolWebClientId is required");
    if (!authConfig.Auth.identityPoolId) throw new Error("Auth identityPoolId is required");
    if (!authConfig.Storage.AWSS3.bucket) throw new Error("Storage bucket name is required");
    if (!authConfig.Storage.AWSS3.region) throw new Error("Storage bucket region is required");
    _this.authConfig = authConfig;
    _this.privateDataExpire = privateDataExpire;
    _this.dataPrivacyLevel = dataPrivacyLevel;

    _awsAmplify.default.configure(_this.authConfig);

    return _this;
  } //Made sure the cognitoSetUp is finish and working


  return CognitoDatasetManager;
}(_events.EventEmitter);

var _default = CognitoDatasetManager;
exports.default = _default;